import { render } from "./GeneratedQueryDisplay.vue?vue&type=template&id=0da8fc9e&scoped=true"
import script from "./GeneratedQueryDisplay.vue?vue&type=script&lang=js"
export * from "./GeneratedQueryDisplay.vue?vue&type=script&lang=js"

import "./GeneratedQueryDisplay.vue?vue&type=style&index=0&id=0da8fc9e&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da8fc9e"]])

export default __exports__